import { useReactiveVar } from '@apollo/client'
import { Divider } from '@material-ui/core'
import React, { useState } from 'react'
import {
  dictionariesVar,
  isCostCalculationSuccessVar,
  selectedCostCalculatorsVar,
  selectedVersionsVar,
} from '../../apollo/reactive-vars'
import { EnergyCalculationMissing } from '../common/EnergyCalculationMissing'
import { Loader } from '../common/Loader'
import { ContainerSelector } from './ContainerSelector'
import { CostBreakdownBarChart } from './cost-charts/CostBreakdownBarChart'
import { CumulativeCostChart } from './cost-charts/CumulativeCostChart'
import { TotalCostsTable } from './cost-tables/TotalCostsTable'

export function CostsResultsPage(): React.ReactElement {
  const isCostCalculationSuccess = useReactiveVar(isCostCalculationSuccessVar)
  const versionCostCalculators = useReactiveVar(selectedCostCalculatorsVar)
  const selectedVersions = useReactiveVar(selectedVersionsVar)
  const { containerIdsToNames } = useReactiveVar(dictionariesVar)
  const [selectedContainerName, setSelectedContainerName] = useState<
    string | null
  >(null)

  if (!isCostCalculationSuccess) {
    return <EnergyCalculationMissing />
  }

  const handleChange = (name: string | null) => {
    setSelectedContainerName(name)
  }

  if (selectedVersions.length !== versionCostCalculators.length) {
    return <Loader />
  }

  return (
    <>
      <ContainerSelector handleChange={handleChange} />
      <Divider />
      <TotalCostsTable
        versions={versionCostCalculators}
        selectedContainerName={selectedContainerName}
        containerIdsToNames={containerIdsToNames}
        selectedVersions={selectedVersions}
        comparisonVersion={versionCostCalculators[0]}
      />
      <Divider />
      <CumulativeCostChart
        versions={versionCostCalculators}
        selectedContainerName={selectedContainerName}
        containerIdsToNames={containerIdsToNames}
      />
      <Divider />
      <CostBreakdownBarChart
        versions={versionCostCalculators}
        selectedContainerName={selectedContainerName}
        containerIdsToNames={containerIdsToNames}
      />
    </>
  )
}
